import React, { Component } from 'react';
import {resolveVariables} from 'functions';

class Small extends React.Component {
    static component_name = 'Small';
    render() {
        return (
            <small>{this.props.text}</small>
        );
    }
}

export default Small;
